var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEye({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-md-eye",
    "data-name": "Icon awesome-clock",
    d: "M8.563.563a8,8,0,1,0,8,8A8,8,0,0,0,8.563.563ZM10.4,11.856,7.559,9.788A.39.39,0,0,1,7.4,9.475V4.046a.388.388,0,0,1,.387-.387H9.337a.388.388,0,0,1,.387.387V8.488l2.048,1.49a.387.387,0,0,1,.084.542l-.91,1.252A.39.39,0,0,1,10.4,11.856Z",
    transform: "translate(-0.563 -0.563)",
    fill: "#666"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.a6da54201a08562ff9a726aafcf7f0c3.svg";
export { ForwardRef as ReactComponent };